import { SimpleTooltip, DisabledOverlay } from "@iventis/components";
import { InteractiveElement, iconButtonSize } from "@iventis/styles";
import { Content } from "@iventis/translations";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo, MouseEvent } from "react";

type EyeIconProps = {
    visible: boolean;
    isEditing: boolean;
    onMouseOver: boolean;
    onClick: (e: MouseEvent<HTMLButtonElement>) => void;
    testId?: string;
    editingTooltip: string;
    hideTooltip: string;
    showTooltip: string;
};

export const EyeIconComponent = ({ visible, isEditing, onMouseOver, testId, onClick, editingTooltip, hideTooltip, showTooltip }: EyeIconProps) => {
    const translate = useIventisTranslate();

    const toolTipText = useMemo(() => {
        if (isEditing) {
            return editingTooltip;
        }
        if (visible) {
            return hideTooltip;
        }
        return showTooltip;
    }, [isEditing, visible, editingTooltip, hideTooltip, showTooltip]);

    const disabled = isEditing;

    return (
        <SimpleTooltip text={translate(toolTipText)} placement="bottom" disabled={!onMouseOver}>
            <span>
                <InteractiveElement
                    className={`node-segment icon eye ${disabled && "disabled"}`}
                    onClick={onClick}
                    style={{ height: iconButtonSize, width: iconButtonSize, zIndex: 100 }}
                    disabled={disabled}
                    data-testid={testId}
                    data-cy={testId}
                >
                    {disabled && <DisabledOverlay opacity={0} />}
                    {visible ? (
                        <span className="hidden">{translate(Content.map3.layerOptionsTooltips.hide_layer)}</span>
                    ) : (
                        <span className="hidden">{translate(Content.map3.layerOptionsTooltips.show_layer)}</span>
                    )}
                    <FontAwesomeIcon icon={visible ? "eye" : "eye-slash"} />
                </InteractiveElement>
            </span>
        </SimpleTooltip>
    );
};
